/**
 * @generated SignedSource<<d6c74aab94942617a14ef6ee9a1d201f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutPaymentMethodContent_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutBankAccounts_viewer" | "CheckoutCheckWrapper_viewer" | "CheckoutCreditCards_viewer" | "CheckoutKlarnaPayment_viewer" | "CheckoutPayPalWrapper_viewer" | "CheckoutWireTransferWrapper_viewer">;
  readonly " $fragmentType": "CheckoutPaymentMethodContent_viewer";
};
export type CheckoutPaymentMethodContent_viewer$key = {
  readonly " $data"?: CheckoutPaymentMethodContent_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutPaymentMethodContent_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutPaymentMethodContent_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutCreditCards_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutPayPalWrapper_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutWireTransferWrapper_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutCheckWrapper_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutBankAccounts_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutKlarnaPayment_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "4c2fcff65b7005960733d46fd3012618";

export default node;
